module.exports = __webpack_public_path__ + "img/products1.937f2afb.svg";